export default __webpack_public_path__ + "static/media/due-date.6acc3ed2.svg";